import React, { useEffect } from 'react'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { useSignal } from '@preact/signals-react'
import { BACKEND_APIS } from '@constants'
import { isReportsHandlerLoading } from 'Pages/Admin/ReportsHandler/@signals'
import useReportsHandlerFilters from 'Pages/Admin/ReportsHandler/@hooks/useFilters'


export default function ReportsHandlerUserOriginFilter() {
	const selectedUser = useSignal(null)
	useReportsHandlerFilters(selectedUser.value)


	useEffect(() => {
		if(selectedUser.value) isReportsHandlerLoading.value = true
	}, [selectedUser.value])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="User Origin"
		placeholder="Select a User Origin"
		value={selectedUser.value}
		onChange={e => selectedUser.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/slaves`}
	/>
}